import React from 'react';
import { connect } from 'react-redux';
import { ActionCreators as UndoActionCreators } from 'redux-undo';

import ArrowLeft from './icons/ArrowLeft';
import ArrowRight from './icons/ArrowRight';

import styles from '../../../../stylesheet/css/header-builder/undo-redo.css';

const UndoRedo = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
}) => {
  return (
    <div className={styles.container}>
      <span
        className={`${styles.command}${!canUndo ? ' ' + styles.disabled : ''}`}
        title="Undo"
        onClick={onUndo}
      >
        <ArrowLeft />
      </span>
      <span
        className={`${styles.command}${!canRedo ? ' ' + styles.disabled : ''}`}
        title="Redo"
        onClick={onRedo}
      >
        <ArrowRight />
      </span>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { activeDevice } = state.model;

  return {
    canUndo: state.model[activeDevice].past.length > 0,
    canRedo: state.model[activeDevice].future.length > 0
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UndoRedo);



// WEBPACK FOOTER //
// ./app/header-builder/components/UndoRedo.js